import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Text from '@atoms/Text/Text';
import { StyledGenericPersonalCard } from '@molecules/PersonalElementsCards/GenericPersonalCard.styles';

export const StyledPersonalElementsCard = styled(StyledGenericPersonalCard)`
  background-color: ${variables.colors.plus};
`;

export const StyledPrice = styled.span`
  color: ${variables.colors.primaryDark};
  margin-left: ${rem(3)};
`;

export const StyledText = styled(Text)`
  white-space: break-spaces;
`;
